import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import {useTheme} from "../../../contexts/theme";

const ContentCardSkeleton = () => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundColor: theme.palette.blue,
                color: theme.palette.white,
                border: `${theme.border.width.thin} solid white`,
            }}
        >
            {/* Simulate the video or image thumbnail */}
            <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{ width: "100%", height: 180 }}
            />

            {/* Simulate the card content */}
            <CardContent sx={{ padding: `${theme.spacing.sm}` }}>
                {/* Simulate text fields */}
                {Array.from({ length: 3 }).map((_, index) => (
                    <Box
                        key={index}
                        sx={{ marginBottom: theme.spacing.xs }}
                    >
                        <Skeleton
                            variant="text"
                            animation="wave"
                            sx={{ fontSize: theme.fontSizes.description }}
                            width={`${Math.random() * (80 - 60) + 60}%`} // Random width for variety
                        />
                        <Skeleton
                            variant="text"
                            animation="wave"
                            sx={{ fontSize: theme.fontSizes.description }}
                            width={`${Math.random() * (40 - 20) + 20}%`}
                        />
                    </Box>
                ))}

                {/* Simulate the buttons */}
                <Box sx={{ display: "flex", flexDirection: "row", gap: theme.spacing.xs }}>
                    {Array.from({ length: 3 }).map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="circular"
                            animation="wave"
                            width={24}
                            height={24}
                        />
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

export default ContentCardSkeleton;
